import ContainerTypeCreateForm from './ContainerTypeCreateForm'

export default ContainerTypeCreateForm
